<template>
  <v-app id="main-vue" >
    <Header/>
    <History/>
    <NoticeBoard/>
    <Carousel/>
    <Gallery/>
    <ProductsList/>
    <Outside/>
    <Footer/>
  </v-app>
</template>

<script>
import Header from './Header.vue'
import Footer from './Footer.vue'
import Outside from './Outside.vue'
import Gallery from './Gallery.vue'
import History from './History.vue'
import Navbar from './Navbar.vue'
import ProductsList from './ProductsList.vue'
import Carousel from './Carousel.vue'
import NoticeBoard from './NoticeBoard.vue'

export default {
  name: 'App',
  components: {
    Header,
    Footer,
    Outside,
    Gallery,
    History,
    Navbar,
    ProductsList,
    Carousel,
    NoticeBoard
  },
  data () {
    return {
      //
    }
  },
  methods: {
  }
}
</script>
<style scoped>
#main-vue{
  overflow: hidden;

}
</style>
